(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2797],{

/***/ 77552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ algolia_card_product; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/molecules/card-product/index.ts + 11 modules
var card_product = __webpack_require__(79208);
// EXTERNAL MODULE: ./lib/utils/product.ts
var product = __webpack_require__(60597);
// EXTERNAL MODULE: ./lib/utils/gtm/helpers.ts
var helpers = __webpack_require__(20457);
// EXTERNAL MODULE: ./lib/utils/price.ts
var price = __webpack_require__(86359);
// EXTERNAL MODULE: ./lib/utils/gtm/normalizeAlgoliaItem.tsx
var normalizeAlgoliaItem = __webpack_require__(23886);
;// CONCATENATED MODULE: ./components/algolia/card-product/CardProductAlgolia.tsx






/**
 * CardProductAlgolia
 */ var CardProductAlgolia = function(param) {
    var hit = param.hit, _type = param.type, type = _type === void 0 ? "COMPLETE" : _type, sendEvent = param.sendEvent, itemListId = param.itemListId, itemListName = param.itemListName, itemIndex = param.itemIndex;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21;
    var isFalseVariable = function(hit) {
        return (0,product/* isVariable */.cG)(hit.type) && hit.variations.length === 1;
    };
    var productID = isFalseVariable(hit) ? hit.variations[0].id : hit.id;
    var productType = isFalseVariable(hit) ? "SIMPLE" : hit.type;
    var onClick = function() {
        (0,helpers/* gtmPush */.De)({
            event: "select_item",
            ecommerce: {
                items: [
                    (0,normalizeAlgoliaItem/* normalizeAlgoliaItem */._)(hit, itemListId, itemListName, itemIndex)
                ]
            }
        });
    };
    var ref22, ref23;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(card_product/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        href: hit.path,
        type: productType,
        productID: productID,
        stock: hit.stock_status,
        hit: hit,
        sendEvent: sendEvent
    }, (hit === null || hit === void 0 ? void 0 : (ref = hit.card) === null || ref === void 0 ? void 0 : ref.box) && (hit === null || hit === void 0 ? void 0 : (ref1 = hit.card) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.box) === null || ref2 === void 0 ? void 0 : ref2.active) ? {
        box: hit === null || hit === void 0 ? void 0 : (ref3 = hit.card) === null || ref3 === void 0 ? void 0 : ref3.box
    } : {}), {
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(card_product/* default.Image */.Z.Image, (0,_object_spread/* default */.Z)({
                src: (ref22 = hit === null || hit === void 0 ? void 0 : (ref4 = hit.card) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.image) === null || ref5 === void 0 ? void 0 : ref5.src) !== null && ref22 !== void 0 ? ref22 : (ref6 = hit.featured_image) === null || ref6 === void 0 ? void 0 : ref6.src,
                alt: (ref23 = hit === null || hit === void 0 ? void 0 : (ref7 = hit.card) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.image) === null || ref8 === void 0 ? void 0 : ref8.alt) !== null && ref23 !== void 0 ? ref23 : (ref9 = hit.featured_image) === null || ref9 === void 0 ? void 0 : ref9.alt
            }, (hit === null || hit === void 0 ? void 0 : (ref10 = hit.card) === null || ref10 === void 0 ? void 0 : ref10.backgroundColor) ? {
                backgroundColor: hit === null || hit === void 0 ? void 0 : (ref11 = hit.card) === null || ref11 === void 0 ? void 0 : ref11.backgroundColor
            } : {})),
            hit.primary_category && /*#__PURE__*/ (0,jsx_runtime.jsx)(card_product/* default.Category */.Z.Category, {
                href: hit.primary_category.path.replace("categoria-producto/", ""),
                children: hit.primary_category.name
            }),
            type === "COMPLETE" && hit.on_sale && /*#__PURE__*/ (0,jsx_runtime.jsx)(card_product/* default.Badge */.Z.Badge, {
                style: hit === null || hit === void 0 ? void 0 : (ref12 = hit.card) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.badge) === null || ref13 === void 0 ? void 0 : ref13.style,
                outline: hit === null || hit === void 0 ? void 0 : (ref14 = hit.card) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.badge) === null || ref15 === void 0 ? void 0 : ref15.outline,
                roundedRight: !(hit === null || hit === void 0 ? void 0 : (ref16 = hit.card) === null || ref16 === void 0 ? void 0 : ref16.life_style),
                children: "-".concat((0,price/* getPercentageDiscount */.To)(hit.regular_price ? hit.regular_price : (ref17 = hit.variations[0]) === null || ref17 === void 0 ? void 0 : ref17.regular_price, hit.sale_price ? hit.sale_price : (ref18 = hit.variations[0]) === null || ref18 === void 0 ? void 0 : ref18.sale_price), "%")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(card_product/* default.Name */.Z.Name, {
                children: (hit === null || hit === void 0 ? void 0 : (ref19 = hit.card) === null || ref19 === void 0 ? void 0 : ref19.name) ? hit.card.name : hit.name
            }),
            hit.seller && hit.seller.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(card_product/* default.Seller */.Z.Seller, {
                children: hit.seller[0]
            }),
            type === "COMPLETE" && hit.on_sale && /*#__PURE__*/ (0,jsx_runtime.jsx)(card_product/* default.PriceRegular */.Z.PriceRegular, {
                children: (0,price/* toCurrency */.j3)(hit.regular_price ? hit.regular_price : (ref20 = hit.variations[0]) === null || ref20 === void 0 ? void 0 : ref20.regular_price)
            }),
            type === "COMPLETE" && /*#__PURE__*/ (0,jsx_runtime.jsx)(card_product/* default.PriceDiscounted */.Z.PriceDiscounted, {
                children: (0,price/* toCurrency */.j3)(hit.price ? hit.price : (ref21 = hit.variations[0]) === null || ref21 === void 0 ? void 0 : ref21.price)
            })
        ]
    }));
};
CardProductAlgolia.displayName = "CardProductAlgolia";
/* harmony default export */ var card_product_CardProductAlgolia = ((/* unused pure expression or super */ null && (CardProductAlgolia)));

;// CONCATENATED MODULE: ./components/algolia/card-product/index.ts

/* harmony default export */ var algolia_card_product = (CardProductAlgolia);


/***/ }),

/***/ 21693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ atoms_link; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/common-tags/es/index.js + 40 modules
var es = __webpack_require__(40865);
// EXTERNAL MODULE: ./components/atoms/link/Link.module.css
var Link_module = __webpack_require__(81434);
var Link_module_default = /*#__PURE__*/__webpack_require__.n(Link_module);
;// CONCATENATED MODULE: ./components/atoms/link/Link.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        ",
        "\n        ",
        "\n        ",
        "\n        ",
        "\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var LinkAbstract = function(_param, ref) {
    var as = _param.as, _type = _param.type, type = _type === void 0 ? "primary" : _type, _size = _param.size, size = _size === void 0 ? "small" : _size, _className = _param.className, className = _className === void 0 ? "" : _className, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "as",
        "type",
        "size",
        "className",
        "children"
    ]);
    var HTMLTag = as || "a";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HTMLTag, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ref: ref,
        className: (0,es/* oneLine */.f9)(_templateObject(), (Link_module_default())["o-link"], (Link_module_default())["o-link--".concat(size)], (Link_module_default())["o-link--".concat(type)], className)
    }, props), {
        children: children
    }));
};
var Link = /*#__PURE__*/ (0,react.forwardRef)(LinkAbstract);

;// CONCATENATED MODULE: ./components/atoms/link/index.ts

/* harmony default export */ var atoms_link = (Link);


/***/ }),

/***/ 95241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function useIntersectionObserver(elementRef, param) {
    var _threshold = param.threshold, threshold = _threshold === void 0 ? 0 : _threshold, _root = param.root, root = _root === void 0 ? null : _root, _rootMargin = param.rootMargin, rootMargin = _rootMargin === void 0 ? "0%" : _rootMargin, _freezeOnceVisible = param.freezeOnceVisible, freezeOnceVisible = _freezeOnceVisible === void 0 ? false : _freezeOnceVisible;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), entry = ref[0], setEntry = ref[1];
    var frozen = (entry === null || entry === void 0 ? void 0 : entry.isIntersecting) && freezeOnceVisible;
    var updateEntry = function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 1), entry = _param[0];
        setEntry(entry);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var node = elementRef === null || elementRef === void 0 ? void 0 : elementRef.current; // DOM Ref
        var hasIOSupport = !!window.IntersectionObserver;
        if (!hasIOSupport || frozen || !node) return;
        var observerParams = {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        };
        var observer = new IntersectionObserver(updateEntry, observerParams);
        observer.observe(node);
        return function() {
            return observer.disconnect();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        elementRef,
        JSON.stringify(threshold),
        root,
        rootMargin,
        frozen
    ]);
    return entry;
}
/* harmony default export */ __webpack_exports__["Z"] = (useIntersectionObserver);


/***/ }),

/***/ 63335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ Edit; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25108);




/**
 * Icono Edit
 */ var Edit = function(param) {
    var className = param.className, _width = param.width, width = _width === void 0 ? _types__WEBPACK_IMPORTED_MODULE_1__/* .defaultProps.width */ .l.width : _width, _height = param.height, height = _height === void 0 ? _types__WEBPACK_IMPORTED_MODULE_1__/* .defaultProps.height */ .l.height : _height, _color = param.color, color = _color === void 0 ? _types__WEBPACK_IMPORTED_MODULE_1__/* .defaultProps.color */ .l.color : _color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, className && {
        className: className
    }), {
        width: width,
        height: height,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M3.333 12.667h.943l6.21-6.21-.943-.942-6.21 6.21v.942ZM14 14H2v-2.829l8.957-8.956a.667.667 0 0 1 .942 0L13.785 4.1a.667.667 0 0 1 0 .942l-7.623 7.624H14V14Zm-3.515-9.428.943.943.943-.943-.943-.943-.943.943Z",
            fill: color
        })
    }));
};


/***/ }),

/***/ 35934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ card_banner; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/atoms/container/index.ts + 3 modules
var container = __webpack_require__(59203);
;// CONCATENATED MODULE: ./components/molecules/card-banner/CardBanner.tsx


/**
 * CardBanner
 */ var CardBanner = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _padding = param.padding, padding = _padding === void 0 ? "p-4" : _padding, align = param.align, justify = param.justify, textAlign = param.textAlign, backgroundColor = param.backgroundColor, backgroundImage = param.backgroundImage, notLazy = param.notLazy, overlay = param.overlay, style = param.style, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
        padding: padding,
        className: "h-full outline outline-1 outline-primary-200 ".concat(className),
        classNameWrapper: "gap-2",
        align: align,
        justify: justify,
        textAlign: textAlign,
        backgroundImage: backgroundImage,
        notLazy: notLazy,
        overlay: overlay,
        backgroundColor: backgroundColor,
        style: style,
        wrapper: true,
        children: children
    });
};
CardBanner.displayName = "CardBanner";

;// CONCATENATED MODULE: ./components/molecules/card-banner/childs/Pretitle.tsx

var Pretitle = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, color = param.color, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "u-actions u-actions--chips ".concat(className),
        style: {
            color: color
        },
        dangerouslySetInnerHTML: {
            __html: children
        }
    });
};

;// CONCATENATED MODULE: ./components/molecules/card-banner/childs/Title.tsx

var Title = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, color = param.color, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "u-headline u-headline@mobile--h2 ".concat(className),
        style: {
            color: color
        },
        dangerouslySetInnerHTML: {
            __html: children
        }
    });
};

;// CONCATENATED MODULE: ./components/molecules/card-banner/childs/Text.tsx

var Text = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, color = param.color, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "u-body u-body--m ".concat(className),
        style: {
            color: color
        },
        dangerouslySetInnerHTML: {
            __html: children
        }
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./components/atoms/next-link/index.ts + 1 modules
var next_link = __webpack_require__(7842);
// EXTERNAL MODULE: ./components/molecules/button/index.ts + 1 modules
var molecules_button = __webpack_require__(25634);
;// CONCATENATED MODULE: ./components/molecules/card-banner/childs/Button.tsx






var Button = function(_param) /*#__PURE__*/ {
    var className = _param.className, _style = _param.style, style = _style === void 0 ? "tertiary" : _style, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, _size = _param.size, size = _size === void 0 ? "normal" : _size, _negative = _param.negative, negative = _negative === void 0 ? false : _negative, _icon = _param.icon, icon = _icon === void 0 ? null : _icon, label = _param.label, href = _param.href, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "style",
        "disabled",
        "size",
        "negative",
        "icon",
        "label",
        "href"
    ]);
    return (0,jsx_runtime.jsx)(next_link/* default */.Z, {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(molecules_button/* default */.Z, (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            as: "a"
        }, className && {
            className: className
        }), {
            style: style,
            disabled: disabled,
            size: size,
            negative: negative,
            icon: icon,
            label: label
        }), props))
    });
};

// EXTERNAL MODULE: ./components/molecules/icon-button/index.ts + 1 modules
var icon_button = __webpack_require__(2234);
;// CONCATENATED MODULE: ./components/molecules/card-banner/childs/IconButton.tsx





/**
 * IconButton
 */ var IconButton = function(param) {
    var className = param.className, children = param.children, href = param.href, style = param.style, size = param.size;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link/* default */.Z, {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_button/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            as: "a",
            style: style,
            size: size
        }, className && {
            className: className
        }), {
            children: children
        }))
    });
};
IconButton.displayName = "IconButton";

;// CONCATENATED MODULE: ./components/molecules/card-banner/index.ts


CardBanner.Pretitle = Pretitle;
CardBanner.Title = Title;
CardBanner.Text = Text;
CardBanner.Button = Button;
CardBanner.IconButton = IconButton;
Pretitle.displayName = "CardBanner.Pretitle";
Title.displayName = "CardBanner.Title";
Text.displayName = "CardBanner.Text";
Button.displayName = "CardBanner.Button";
IconButton.displayName = "CardBanner.IconButton";
/* harmony default export */ var card_banner = (CardBanner);


/***/ }),

/***/ 21971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ GridItem; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var common_tags__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40865);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      col-span-",
        "\n      ",
        "\n      ",
        "\n      ",
        "\n      ",
        "\n      ",
        "\n      ",
        "\n      row-span-",
        "\n      ",
        "\n      ",
        "\n      ",
        "\n      ",
        "\n      ",
        "\n      ",
        "\n      ",
        "\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/**
 * GridItem
 */ var GridItem = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _colSpanXXS = param.colSpanXXS, colSpanXXS = _colSpanXXS === void 0 ? 1 : _colSpanXXS, colSpanXS = param.colSpanXS, colSpanSM = param.colSpanSM, colSpanMD = param.colSpanMD, colSpanLG = param.colSpanLG, colSpanXL = param.colSpanXL, colSpanXXL = param.colSpanXXL, _rowSpanXXS = param.rowSpanXXS, rowSpanXXS = _rowSpanXXS === void 0 ? 1 : _rowSpanXXS, rowSpanXS = param.rowSpanXS, rowSpanSM = param.rowSpanSM, rowSpanMD = param.rowSpanMD, rowSpanLG = param.rowSpanLG, rowSpanXL = param.rowSpanXL, rowSpanXXL = param.rowSpanXXL, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: (0,common_tags__WEBPACK_IMPORTED_MODULE_2__/* .oneLine */ .f9)(_templateObject(), colSpanXXS, colSpanXS ? "xs:col-span-".concat(colSpanXS) : "", colSpanSM ? "sm:col-span-".concat(colSpanSM) : "", colSpanMD ? "md:col-span-".concat(colSpanMD) : "", colSpanLG ? "lg:col-span-".concat(colSpanLG) : "", colSpanXL ? "xl:col-span-".concat(colSpanXL) : "", colSpanXXL ? "2xl:col-span-".concat(colSpanXXL) : "", rowSpanXXS, rowSpanXS ? "xs:row-span-".concat(rowSpanXS) : "", rowSpanSM ? "sm:row-span-".concat(rowSpanSM) : "", rowSpanMD ? "md:row-span-".concat(rowSpanMD) : "", rowSpanLG ? "lg:row-span-".concat(rowSpanLG) : "", rowSpanXL ? "xl:row-span-".concat(rowSpanXL) : "", rowSpanXXL ? "2xl:row-span-".concat(rowSpanXXL) : "", className),
        children: children
    });
};


/***/ }),

/***/ 23034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ grid; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/common-tags/es/index.js + 40 modules
var es = __webpack_require__(40865);
// EXTERNAL MODULE: ./components/molecules/grid/Grid.module.css
var Grid_module = __webpack_require__(39586);
var Grid_module_default = /*#__PURE__*/__webpack_require__.n(Grid_module);
;// CONCATENATED MODULE: ./components/molecules/grid/Grid.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        "\n      ",
        "\n      grid-cols-",
        "\n      xs:grid-cols-",
        "\n      sm:grid-cols-",
        "\n      md:grid-cols-",
        "\n      lg:grid-cols-",
        "\n      ",
        "\n      ",
        "\n      ",
        "\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/**
 * Grid
 */ var Grid = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, style = param.style, _outline = param.outline, outline = _outline === void 0 ? true : _outline, _xxs = param.xxs, xxs = _xxs === void 0 ? 1 : _xxs, _xs = param.xs, xs = _xs === void 0 ? 2 : _xs, _sm = param.sm, sm = _sm === void 0 ? 3 : _sm, _md = param.md, md = _md === void 0 ? 4 : _md, _lg = param.lg, lg = _lg === void 0 ? 6 : _lg, xl = param.xl, xxl = param.xxl, refProp = param.refProp, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,es/* oneLine */.f9)(_templateObject(), (Grid_module_default())["c-grid"], outline ? (Grid_module_default())["c-grid--outline"] : "", xxs, xs, sm, md, lg, xl ? "xl:grid-cols-".concat(xl) : "", xxl ? "2xl:grid-cols-".concat(xxl) : "", className),
        ref: refProp,
        style: style,
        children: children
    });
};

// EXTERNAL MODULE: ./components/molecules/grid/GridItem.tsx
var GridItem = __webpack_require__(21971);
;// CONCATENATED MODULE: ./components/molecules/grid/index.ts


Grid.Item = GridItem/* GridItem */.P;
GridItem/* GridItem.displayName */.P.displayName = "Grid.Item";
/* harmony default export */ var grid = (Grid);


/***/ }),

/***/ 14529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ product_block; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/atoms/next-link/index.ts + 1 modules
var next_link = __webpack_require__(7842);
// EXTERNAL MODULE: ./components/atoms/text/index.ts + 1 modules
var atoms_text = __webpack_require__(61150);
// EXTERNAL MODULE: ./components/atoms/link/index.ts + 1 modules
var atoms_link = __webpack_require__(21693);
// EXTERNAL MODULE: ./components/hooks/useIntersectionObserver.ts
var useIntersectionObserver = __webpack_require__(95241);
// EXTERNAL MODULE: ./lib/utils/gtm/helpers.ts
var helpers = __webpack_require__(20457);
// EXTERNAL MODULE: ./lib/utils/gtm/normalizeAlgoliaItems.tsx
var normalizeAlgoliaItems = __webpack_require__(90451);
// EXTERNAL MODULE: ./lib/utils/gtm/normalizeItem.tsx
var normalizeItem = __webpack_require__(44538);
;// CONCATENATED MODULE: ./lib/utils/gtm/normalizeItems.tsx

var normalizeItems = function(data, id, name) {
    return data.map(function(itm, index) {
        return (0,normalizeItem/* normalizeItem */.V)(itm, id, name, index);
    });
};

// EXTERNAL MODULE: ./components/organisms/product-block/ProductBlock.module.css
var ProductBlock_module = __webpack_require__(47759);
var ProductBlock_module_default = /*#__PURE__*/__webpack_require__.n(ProductBlock_module);
;// CONCATENATED MODULE: ./components/organisms/product-block/ProductBlock.tsx








/**
 * ProductBlock
 */ var ProductBlock = function(param) {
    var className = param.className, title = param.title, description = param.description, link = param.link, children = param.children, itemListId = param.itemListId, itemListName = param.itemListName, itemIndex = param.itemIndex, productos = param.productos;
    var ref = (0,react.useRef)(null);
    var entry = (0,useIntersectionObserver/* default */.Z)(ref, {
        freezeOnceVisible: true
    });
    var isVisible = !!(entry === null || entry === void 0 ? void 0 : entry.isIntersecting);
    (0,react.useEffect)(function() {
        if (isVisible && productos) {
            var ref;
            if ((ref = productos === null || productos === void 0 ? void 0 : productos.at(0)) === null || ref === void 0 ? void 0 : ref.hasOwnProperty("_highlightResult")) {
                var ref1;
                (0,helpers/* gtmPush */.De)({
                    event: "view_item_list",
                    ecommerce: {
                        items: (0,normalizeAlgoliaItems/* normalizeAlgoliaItems */.A)((ref1 = productos === null || productos === void 0 ? void 0 : productos.filter(Boolean)) === null || ref1 === void 0 ? void 0 : ref1.filter(function(item) {
                            return (item === null || item === void 0 ? void 0 : item.__typename) !== "Banner";
                        }), itemListId, itemListName)
                    }
                });
            } else {
                var ref2;
                (0,helpers/* gtmPush */.De)({
                    event: "view_item_list",
                    ecommerce: {
                        items: normalizeItems((ref2 = productos === null || productos === void 0 ? void 0 : productos.filter(Boolean)) === null || ref2 === void 0 ? void 0 : ref2.filter(function(item) {
                            return (item === null || item === void 0 ? void 0 : item.__typename) !== "Banner";
                        }), itemListId, itemListName, itemIndex)
                    }
                });
            }
        }
    }, [
        isVisible
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, className && {
        className: className
    }), {
        ref: ref,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ProductBlock_module_default())["c-product-block__header"],
                children: [
                    (title || link) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row items-center justify-between gap-8 md:gap-12",
                        children: [
                            title && link ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link/* default */.Z, {
                                    href: link.href,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_text/* default */.Z, {
                                            className: (ProductBlock_module_default())["c-product-block__title"],
                                            children: title
                                        })
                                    })
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_text/* default */.Z, {
                                htmlTag: "h2",
                                className: (ProductBlock_module_default())["c-product-block__title"],
                                children: title
                            }),
                            link && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link/* default */.Z, {
                                href: link.href,
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_link/* default */.Z, {
                                    size: link.size,
                                    type: link.style,
                                    className: (ProductBlock_module_default())["c-product-block__link"],
                                    children: link.label
                                })
                            })
                        ]
                    }),
                    description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "u-body u-body--xl pt-2 text-typo-secondary",
                        children: description
                    })
                ]
            }),
            children
        ]
    }));
};

;// CONCATENATED MODULE: ./components/organisms/product-block/index.ts

/* harmony default export */ var product_block = (ProductBlock);


/***/ }),

/***/ 13660:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _atoms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59203);
/* harmony import */ var _molecules__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23034);
/* harmony import */ var _molecules__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35934);
/* harmony import */ var _organisms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14529);
/* harmony import */ var _components_algolia__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(77552);
/* harmony import */ var _lib_graphql_transformers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(92722);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82702);









var ProductsByBrand = function(param) {
    var bloque = param.bloque, id = param.id;
    var ref;
    var titulo = bloque.titulo, backgroundColor = bloque.backgroundColor, description = bloque.description, link = bloque.link, products = bloque.products, path = bloque.path;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        id: id,
        wrapper: true,
        as: "section"
    }, backgroundColor ? {
        style: {
            backgroundColor: backgroundColor
        },
        padding: "px-4 py-8 md:py-16"
    } : {}), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_organisms__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, titulo ? {
            title: titulo
        } : {}, link && ((ref = link.link) === null || ref === void 0 ? void 0 : ref.url) && (link === null || link === void 0 ? void 0 : link.label) ? {
            link: {
                href: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_5__/* .removeBaseURL */ .t7)(link.link.url),
                label: link.label,
                size: link.size,
                style: link.style
            }
        } : {}, description ? {
            description: description
        } : {}), {
            productos: products,
            itemListId: path,
            itemListName: path,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_molecules__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                children: products.map(function(p, i) {
                    if ("__typename" in p && p.__typename === "Banner") {
                        var ref;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_molecules__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Item */ .Z.Item, {
                            colSpanXXS: (p === null || p === void 0 ? void 0 : (ref = p.cpt_banner) === null || ref === void 0 ? void 0 : ref.double) ? 2 : 1,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_molecules__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, (0,_lib_graphql_transformers__WEBPACK_IMPORTED_MODULE_8__/* .cardBannerTransformer */ .$)(p.cpt_banner)))
                        }, i);
                    }
                    if ("sku" in p) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_molecules__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Item */ .Z.Item, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_algolia__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                hit: p,
                                itemListId: path,
                                itemListName: path,
                                itemIndex: i
                            })
                        }, p.id);
                    }
                })
            })
        }))
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (ProductsByBrand);
ProductsByBrand.displayName = "ProductsByBrand";


/***/ }),

/***/ 92722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ cardBannerTransformer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/molecules/card-banner/index.ts + 6 modules
var card_banner = __webpack_require__(35934);
// EXTERNAL MODULE: ./lib/graphql/transformers/common/container.ts
var common_container = __webpack_require__(57797);
// EXTERNAL MODULE: ./components/icons/index.ts + 24 modules
var icons = __webpack_require__(72516);
;// CONCATENATED MODULE: ./lib/graphql/transformers/common/icon.ts

var _icon;
var iconTransformer = function(icon) {
    return (_icon = icons[icon]) !== null && _icon !== void 0 ? _icon : null;
};

;// CONCATENATED MODULE: ./lib/graphql/transformers/card-banner/card.tsx






var cardBannerTransformer = function(card) {
    var container = (0,common_container/* containerTransformer */.a)(card);
    var children = card.content.map(function(item, index) {
        var Component = null;
        switch(item.__typename){
            case "Banner_CptBanner_Content_Pretitle":
                Component = /*#__PURE__*/ (0,react.createElement)(card_banner/* default.Pretitle */.Z.Pretitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (item === null || item === void 0 ? void 0 : item.color) ? {
                    color: item.color
                } : {}), {
                    key: index
                }), item.text);
                break;
            case "Banner_CptBanner_Content_Title":
                Component = /*#__PURE__*/ (0,react.createElement)(card_banner/* default.Title */.Z.Title, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (item === null || item === void 0 ? void 0 : item.color) ? {
                    color: item.color
                } : {}, (item === null || item === void 0 ? void 0 : item.size) ? {
                    className: item.size
                } : {}), {
                    key: index
                }), item.text);
                break;
            case "Banner_CptBanner_Content_Button":
                var ref;
                Component = (item === null || item === void 0 ? void 0 : (ref = item.link) === null || ref === void 0 ? void 0 : ref.url) && (item === null || item === void 0 ? void 0 : item.label) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(card_banner/* default.Button */.Z.Button, {
                    style: item.style,
                    href: item.link.url,
                    label: item.label,
                    negative: item.negativo,
                    size: item.size
                }, index) : null;
                break;
            case "Banner_CptBanner_Content_Text":
                Component = /*#__PURE__*/ (0,react.createElement)(card_banner/* default.Text */.Z.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (item === null || item === void 0 ? void 0 : item.color) ? {
                    color: item.color
                } : {}), {
                    key: index
                }), item.text);
                break;
            case "Banner_CptBanner_Content_ButtonIcon":
                var Icon = iconTransformer(item.icon);
                Component = (item === null || item === void 0 ? void 0 : item.icon) && (item === null || item === void 0 ? void 0 : item.linkText) && /*#__PURE__*/ (0,react.createElement)(card_banner/* default.IconButton */.Z.IconButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (item === null || item === void 0 ? void 0 : item.size) ? {
                    size: item.size
                } : {}, (item === null || item === void 0 ? void 0 : item.style) ? {
                    style: item.style
                } : {}), {
                    href: item.linkText,
                    key: index
                }), /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {}));
        }
        return Component;
    });
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, container, {
        style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, container.style), {
            minHeight: "".concat(card.minHeight, "px")
        })
    }), {
        padding: card.double ? "p-3 xs:p-8" : "p-3",
        children: children
    });
};


/***/ }),

/***/ 57797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ containerTransformer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26042);

var containerTransformer = function(container) {
    var ref, ref1, ref2;
    var ref3;
    var SRCSet = (ref3 = container === null || container === void 0 ? void 0 : container.srcset) !== null && ref3 !== void 0 ? ref3 : [];
    var baseImage = container === null || container === void 0 ? void 0 : (ref = container.imagenBase) === null || ref === void 0 ? void 0 : ref.sourceUrl;
    var layoutImages = [];
    SRCSet === null || SRCSet === void 0 ? void 0 : SRCSet.map(function(image) {
        var ref;
        layoutImages.push({
            media: image.anchura,
            src: (ref = image.imagen) === null || ref === void 0 ? void 0 : ref.sourceUrl
        });
    });
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, (container === null || container === void 0 ? void 0 : container.imagenBase) ? (container === null || container === void 0 ? void 0 : (ref1 = container.imagenBase) === null || ref1 === void 0 ? void 0 : ref1.sourceUrl) ? {
        backgroundImage: {
            src: baseImage,
            srcset: layoutImages,
            alt: container === null || container === void 0 ? void 0 : (ref2 = container.imagenBase) === null || ref2 === void 0 ? void 0 : ref2.altText
        }
    } : {
        backgroundImage: baseImage
    } : {}, (container === null || container === void 0 ? void 0 : container.colorDeFondo) ? {
        style: {
            backgroundColor: container === null || container === void 0 ? void 0 : container.colorDeFondo
        }
    } : {}, (container === null || container === void 0 ? void 0 : container.overlay) ? {
        overlay: (container === null || container === void 0 ? void 0 : container.overlay) / 100
    } : {}, (container === null || container === void 0 ? void 0 : container.justify) ? {
        justify: container === null || container === void 0 ? void 0 : container.justify.reduce(function(previousValue, currentValue) {
            return "".concat(previousValue, " ").concat(currentValue.mediaQuery === "none" ? currentValue.justify : "".concat(currentValue.mediaQuery, ":").concat(currentValue.justify));
        }, "")
    } : {}, (container === null || container === void 0 ? void 0 : container.align) ? {
        align: container === null || container === void 0 ? void 0 : container.align.reduce(function(previousValue, currentValue) {
            return "".concat(previousValue, " ").concat(currentValue.mediaQuery === "none" ? currentValue.align : "".concat(currentValue.mediaQuery, ":").concat(currentValue.align));
        }, "")
    } : {}, (container === null || container === void 0 ? void 0 : container.textAlign) ? {
        textAlign: container === null || container === void 0 ? void 0 : container.textAlign.reduce(function(previousValue, currentValue) {
            return "".concat(previousValue, " ").concat(currentValue.mediaQuery === "none" ? currentValue.textAlign : "".concat(currentValue.mediaQuery, ":").concat(currentValue.textAlign));
        }, "")
    } : {});
};


/***/ }),

/***/ 23886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ normalizeAlgoliaItem; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _price__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86359);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20457);





var normalizeAlgoliaItem = function(item, itemListId, itemListName, index) {
    var regularPrice = item.regular_price;
    var salePrice = item.sale_price;
    if (item.variations.length > 0) {
        regularPrice = item.variations[0].regular_price;
        salePrice = item.variations[0].sale_price;
    }
    var discount = item.on_sale ? Number.parseFloat((0,_price__WEBPACK_IMPORTED_MODULE_0__/* .getDiscountAmount */ .TC)(regularPrice, salePrice).toFixed(2)) : null;
    // TODO: cuando se implmente el buy box esto no servirá porque puede haber varios sellers
    var seller = _helpers__WEBPACK_IMPORTED_MODULE_1__/* .AFFILIATION_NAME_OPERATOR */ .lZ;
    if ((item === null || item === void 0 ? void 0 : item.seller[0]) !== "BigCrafters") {
        var ref;
        seller = (ref = item === null || item === void 0 ? void 0 : item.seller[0]) !== null && ref !== void 0 ? ref : null;
    }
    var itemToAdd = {
        item_id: item.sku,
        item_name: item.name,
        // TODO: cuando se implmente el buy box esto no servirá porque puede haber varios sellers
        affiliation: seller,
        coupon: null,
        currency: "EUR",
        discount: discount,
        index: index !== null && index !== void 0 ? index : null,
        item_brand: Array.isArray(item === null || item === void 0 ? void 0 : item.marca) ? item.marca[0] : null,
        item_list_id: itemListId !== undefined ? itemListId : null,
        item_list_name: itemListName !== undefined ? itemListName : null,
        item_variant: null,
        price: regularPrice,
        quantity: 1
    };
    if (item.tags.length > 0) {
        var categories = {};
        for(var i = 0; i < item.tags.length; ++i){
            var catLabel = i === 0 ? "item_category" : "item_category".concat(i + 1);
            categories = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, categories), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, catLabel, item.tags[i].name));
        }
        itemToAdd = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, itemToAdd, categories);
    }
    return itemToAdd;
};


/***/ }),

/***/ 90451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ normalizeAlgoliaItems; }
/* harmony export */ });
/* harmony import */ var _normalizeAlgoliaItem__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23886);

var normalizeAlgoliaItems = function(items, itemListId, itemListName) {
    return items.map(function(item, index) {
        return (0,_normalizeAlgoliaItem__WEBPACK_IMPORTED_MODULE_0__/* .normalizeAlgoliaItem */ ._)(item, itemListId, itemListName, index);
    });
};


/***/ }),

/***/ 81434:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"o-link":"Link_o-link__Tl_HK","o-link--primary":"Link_o-link--primary__c8Ss7","o-link--secondary":"Link_o-link--secondary__PQGb_","o-link--alternative":"Link_o-link--alternative__U5JcF","o-link--current-color":"Link_o-link--current-color__zPjFz","o-link--small":"Link_o-link--small__QLuw1","o-link--large":"Link_o-link--large__6FRJr","o-link--body":"Link_o-link--body__IFdjn"};

/***/ }),

/***/ 39586:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"c-grid":"Grid_c-grid__qnXWE","c-grid--outline":"Grid_c-grid--outline__B9A9Y"};

/***/ }),

/***/ 47759:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"c-product-block__header":"ProductBlock_c-product-block__header__UFK09","c-product-block__title":"ProductBlock_c-product-block__title__ifA_r","c-product-block__link":"ProductBlock_c-product-block__link___kEof"};

/***/ }),

/***/ 828:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}


/***/ })

}]);